export function formatCommissioningBusinessType(businessType) {
  if (!businessType) {
    return null;
  }

  if (typeof businessType !== 'object') {
    return String(businessType);
  }

  if (businessType.industry_not_found) {
    return businessType.industry_text || null;
  }

  return [businessType.industry_code, businessType.industry_text]
    .filter((value) => value !== null && value !== undefined && value !== '')
    .join(', ');
}

export function isUnresolvedCommissioningBusinessType(businessType) {
  if (!businessType || typeof businessType !== 'object') {
    return false;
  }

  const industryCode = businessType.industry_code;

  return (
    businessType.industry_not_found === true &&
    (industryCode === null ||
      industryCode === undefined ||
      String(industryCode).trim() === '')
  );
}

export function isCommissioningCustomerIndustryRequired(contactPerson = {}) {
  const normalizedTitle = String(contactPerson.title || '')
    .replace(/\s+/g, '')
    .toLocaleLowerCase('de');

  return normalizedTitle === 'firma' || normalizedTitle === 'stadt/kommune';
}
